var map = {
	"./Anemo-Dark.png": "toe+",
	"./Anemo.png": "u+X7",
	"./Cryo-Dark.png": "XprO",
	"./Cryo.png": "WY3T",
	"./Dendro-Dark.png": "2EDB",
	"./Electro-Dark.png": "gWzu",
	"./Electro.png": "mpn9",
	"./Geo-Dark.png": "5Ahs",
	"./Geo.png": "MWlj",
	"./Hydro-Dark.png": "T1t0",
	"./Hydro.png": "wwH9",
	"./Loading-Icons.png": "ahvn",
	"./Pyro-Dark.png": "Vvpc",
	"./Pyro.png": "GoUt"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "XPVX";